import { COLORS } from '@btime/constants'
import { capitalizeAllIfLower, capitalizeIfLower } from '@btime/helpers'
import { prop } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { RefetchingIndicator } from '../../../../components/helpers/StatePresenter'
import { TableColumn, useRowActionsColumn } from '../../../../components/tables/Table'
import { Text } from '../../../../components/presentation/Text'
import { placesClient } from '../../../../utils/apollo/api'
import { useAssetActions } from '../../_actions/assetActions'
import { useAssets } from '../_load/AssetsLoader'
import { useOpenAssetModal } from '../../../../utils/routes/modals/modalsActions'
import { usePlaceTypes } from '../../../../utils/helpers/placeTypes'
import DataTable from '../../../../packages/kiti/components/table/DataTable'
import EditableAsset from '../../../../containers/assets/EditableAsset'
import Link from '../../../../components/actions/Link'
import ListCounter from '../../../../components/helpers/ListCounter'
import MinicrudSelect from '../../../../containers/minicruds/select/MinicrudSelect'
import PlacePresenter from '../../../../containers/places/PlacePresenter'
import PlaceSelect from '../../../../containers/places/select/PlaceSelect'
import SwitchDisabled from '../../../../components/helpers/disabled/SwitchDisabled'

const AssetTable = () => {
  const { t } = useTranslation('listAsset')

  const data = useAssets()
  const openDetailsModal = useOpenAssetModal()
  const [placeTypes] = usePlaceTypes()

  const columns = [
    {
      label: t('name'),
      headerSideContent: (
        <>
          <ListCounter
            client={placesClient}
            entity="assets"
            filterName="AssetFilter "
            filters={{ includeDisabled: true }}
          />
          <RefetchingIndicator />
        </>
      ),
      dataIndex: 'name',
      sortIndex: 'NAME',
      flex: 3,
      render: (value, record) => (
        <EditableAsset record={record} field="name">
          <Link onClick={() => openDetailsModal(record)} block>
            <Text strong color={COLORS.dark2} breakWord>
              {capitalizeAllIfLower(value)}
            </Text>
          </Link>
        </EditableAsset>
      )
    },

    {
      label: placeTypes?.map(prop('name')).join(' / '),
      dataIndex: 'place',
      sortIndex: 'PLACE_NAME',
      flex: 3,
      render: (item, record) => (
        <EditableAsset record={record} field="place" Input={PlaceSelect}>
          <PlacePresenter place={item} size="small" color={COLORS.dark3} hideIcon breakWord />
        </EditableAsset>
      )
    },

    {
      label: t('type'),
      dataIndex: ['type', 'name'],
      sortIndex: 'TYPE_NAME',
      flex: 1,
      render: (value, record) => (
        <EditableAsset record={record} field="type" Input={MinicrudSelect} entity="assetType">
          <TableColumn>{capitalizeIfLower(value)}</TableColumn>
        </EditableAsset>
      )
    },

    {
      label: t('enabled'),
      dataIndex: 'enabled',
      sortIndex: false,
      width: 4,
      render: (_, record) => <SwitchDisabled client={placesClient} entity="Asset" record={record} size={'small'} />
    },

    {
      label: t('actions'),
      width: 3,
      render: useRowActionsColumn(useAssetActions)
    }
  ]

  return <DataTable rowKey="id" columns={columns} size="medium" inPanel data={data} />
}

export default AssetTable
